import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import LogoImg from "assets/images/logo.svg";
import { useContext } from "react";
import { UserContext } from "context/userContext";
import Navigation from "layout/MainLayout/components/Navigation";
import User from "layout/MainLayout/components/User";
import { HEADER_HEIGHT } from "constants/global";

const Header = () => {
  const { me, meError, meLoading } = useContext(UserContext);
  const isAuth = !!me && !meError && !meLoading;

  return (
    <AppBar
      position='static'
      sx={{ height: HEADER_HEIGHT }}>
      <Container
        maxWidth='xl'
        sx={{ paddingX: { sm: 3 } }}>
        <Toolbar
          disableGutters
          sx={{
            alignItems: "center",
            overflow: "auto",
            scrollbarWidth: 0,
            p: 0,
            minHeight: `${HEADER_HEIGHT} !important`,
            "::-webkit-scrollbar": { display: "none" },
          }}>
          <Box
            src={LogoImg}
            component='img'
            alt='MyHRBox Logo'
            sx={{ height: 40, width: 172, mr: 3 }}
          />
          <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center", mr: 1.5 }}>
            <Navigation isAuth={isAuth} />
            {/* TODO: убрали за ненадобностью, в будущем может понадобиться */}
            {/* {isAuth && currentCompany?.identification && (
              <SecretCompanyCode
                code={currentCompany?.identification}
                sx={{ ml: 4 }}
              />
            )} */}
          </Box>
          {isAuth && <User />}
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default Header;
